// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__3GOzp","cover":"Image_cover__cg_EE","remove":"Image_remove__mkejB"};